export default __webpack_public_path__ + "static/45489-34542739f53d5cc6f2d2d38789c7cedf.jpg";